module.exports = __webpack_public_path__ + "resources/img/img_vehicle_process2_m.0750707d2e719e4cbf9120b038cefade.png";